/**
 * Comportement standard des <input type="number"> admin :
 * - focus → sélectionne tout (remplacement direct à la saisie)
 * - molette → ne modifie pas la valeur (évite les erreurs de scroll)
 */

export function preventNumberInputWheel(event) {
  if (!event) return;
  event.preventDefault();
  event.currentTarget?.blur();
}

export function selectNumberInputOnFocus(event) {
  const el = event.currentTarget;
  if (typeof el?.select === 'function') {
    requestAnimationFrame(() => el.select());
  }
}

export const NUMBER_INPUT_PROPS = {
  onWheel: preventNumberInputWheel,
  onFocus: selectNumberInputOnFocus,
};
